import { Navigate, type RouteObject } from 'react-router-dom';
import { Layout } from './components/Layout';
import { AddStrain } from './pages/AddStrain';
import { Calculator } from './pages/Calculator';
import { Catalogue } from './pages/Catalogue';
import { Dashboard } from './pages/Dashboard';
import { DevDashboard } from './pages/DevDashboard';
import { DevOcr } from './pages/DevOcr';
import { DoseCalculator } from './pages/DoseCalculator';
import { EditStrain } from './pages/EditStrain';
import { ImportCatalogueBootstrap } from './pages/ImportCatalogueBootstrap';
import { Install } from './pages/Install';
import { Journal } from './pages/Journal';
import { NotFound } from './pages/NotFound';
import { Settings } from './pages/Settings';
import { Admin } from './pages/Admin';
import { SpinWheel } from './pages/SpinWheel';
import { StrainDetails } from './pages/StrainDetails';
import { HOME_PATH } from './lib/navigation';

const devRoutes: RouteObject[] = import.meta.env.DEV
  ? [
      { path: 'dev', element: <DevDashboard /> },
      { path: 'dev/ocr', element: <DevOcr /> },
    ]
  : [];

export const appRoutes: RouteObject[] = [
  { path: '/install', element: <Install /> },
  {
    path: HOME_PATH,
    element: <Layout />,
    children: [
      { index: true, element: <Catalogue /> },
      { path: 'catalogue', element: <Catalogue /> },
      { path: 'history', element: <Dashboard /> },
      { path: 'add', element: <AddStrain /> },
      {
        path: 'add/import-catalogue',
        element: <ImportCatalogueBootstrap />,
      },
      { path: 'strains/:id', element: <StrainDetails /> },
      { path: 'strains/:id/edit', element: <EditStrain /> },
      { path: 'calculator', element: <Calculator /> },
      { path: 'dose', element: <DoseCalculator /> },
      { path: 'spin', element: <SpinWheel /> },
      { path: 'rituals', element: <Journal /> },
      { path: 'journal', element: <Navigate to="/rituals" replace /> },
      { path: 'settings', element: <Settings /> },
      { path: 'admin', element: <Admin /> },
      ...devRoutes,
      { path: '*', element: <NotFound /> },
    ],
  },
];
